import type { Task, Timesheet, FilterCategory } from '@/types'

export interface FilterParams {
  category: string
  engineer: string
  period: number
  customDateFrom: string | null
  customDateTo: string | null
  activeEngineers: string[]
  activeProjectIds: number[]
}

export function matchTask(t: Task, f: FilterParams): boolean {
  if (t.cancelled) return false
  if (!f.activeProjectIds.includes(t.projId)) return false
  if (t.users.length > 0 && !t.users.some(u => f.activeEngineers.includes(u))) return false
  if (f.category !== 'all' && t.cat !== f.category) return false
  if (f.engineer !== 'all' && !t.users.includes(f.engineer)) return false
  return true
}

export function matchTS(ts: Timesheet, f: FilterParams): boolean {
  if (!f.activeEngineers.includes(ts.user)) return false
  if (f.category !== 'all' && ts.cat !== f.category) return false
  if (f.engineer !== 'all' && ts.user !== f.engineer) return false
  return true
}

export function inPeriod(dateStr: string, f: FilterParams): boolean {
  if (!dateStr) return false
  const d = new Date(dateStr)
  if (f.customDateFrom && f.customDateTo) {
    return d >= new Date(f.customDateFrom) && d <= new Date(f.customDateTo + 'T23:59:59')
  }
  const cutoff = new Date()
  cutoff.setDate(cutoff.getDate() - f.period)
  return d >= cutoff
}

// The period of equal length immediately preceding the current one, so "this
// period vs last period" compares like-for-like windows.
export function inPreviousPeriod(dateStr: string, f: FilterParams): boolean {
  if (!dateStr) return false
  const d = new Date(dateStr)
  if (f.customDateFrom && f.customDateTo) {
    const from = new Date(f.customDateFrom)
    const to = new Date(f.customDateTo + 'T23:59:59')
    const lengthMs = to.getTime() - from.getTime()
    const prevTo = new Date(from.getTime() - 1)
    const prevFrom = new Date(from.getTime() - lengthMs - 1)
    return d >= prevFrom && d <= prevTo
  }
  const end = new Date()
  end.setDate(end.getDate() - f.period)
  const start = new Date()
  start.setDate(start.getDate() - f.period * 2)
  return d >= start && d < end
}

export function inDateRange(dateStr: string, from: string, to: string): boolean {
  if (!dateStr) return false
  const d = new Date(dateStr)
  return d >= new Date(from) && d <= new Date(to + 'T23:59:59')
}
